import React, { useEffect, useRef } from 'react';

interface Props {
  tourIds: string;
}

const GetYourGuideWidget: React.FC<Props> = ({ tourIds }) => {
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (widgetRef.current) {
      // Clear old content to re-render widget
      widgetRef.current.innerHTML = '';

      const script = document.createElement('script');
      script.src = 'https://widget.getyourguide.com/dist/embed.js';
      script.async = true;
      widgetRef.current.appendChild(script);

      // Append the widget container
      const container = document.createElement('div');
      container.setAttribute(
        'data-gyg-href',
        'https://widget.getyourguide.com/default/activities.frame'
      );
      container.setAttribute('data-gyg-locale-code', 'en-US');
      container.setAttribute('data-gyg-widget', 'activities');
      container.setAttribute('data-gyg-number-of-items', '3');
      container.setAttribute('data-gyg-partner-id', 'Q3VFO4H');
      container.setAttribute('data-gyg-tour-ids', tourIds);
      widgetRef.current.appendChild(container);
    }
  }, [tourIds]);

  return <div ref={widgetRef} />;
};

export default GetYourGuideWidget;
